/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
    ProviderDirectoryContactTypeToJSONTyped,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface ProviderDirectoryContact
 */
export interface ProviderDirectoryContact {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    provider_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    position?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    contact_type: ProviderDirectoryContactType;
    /**
     * 
     */
    user_id?: string | null;
}



/**
 * Check if a given object implements the ProviderDirectoryContact interface.
 */
export function instanceOfProviderDirectoryContact(value: object): value is ProviderDirectoryContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('provider_id' in value) || value['provider_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contact_type' in value) || value['contact_type'] === undefined) return false;
    return true;
}

export function ProviderDirectoryContactFromJSON(json: any): ProviderDirectoryContact {
    return ProviderDirectoryContactFromJSONTyped(json, false);
}

export function ProviderDirectoryContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderDirectoryContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'provider_id': json['provider_id'],
        'name': json['name'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contact_type': ProviderDirectoryContactTypeFromJSON(json['contact_type']),
        'user_id': json['user_id'] === undefined ? undefined : json['user_id'] === null ? null : json['user_id'],
    };
}

export function ProviderDirectoryContactToJSON(json: any): ProviderDirectoryContact {
    return ProviderDirectoryContactToJSONTyped(json, false);
}

export function ProviderDirectoryContactToJSONTyped(value?: ProviderDirectoryContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'provider_id': value['provider_id'],
        'name': value['name'],
        'position': value['position'],
        'email': value['email'],
        'phone': value['phone'],
        'contact_type': ProviderDirectoryContactTypeToJSON(value['contact_type']),
        'user_id': value['user_id'],
    };
}

